import { render, staticRenderFns } from "./DailyCoversList.vue?vue&type=template&id=7456ac0c&"
import script from "./DailyCoversList.vue?vue&type=script&lang=js&"
export * from "./DailyCoversList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports